import { render, staticRenderFns } from "./rulesUsers.vue?vue&type=template&id=94907ebc"
import script from "./rulesUsers.vue?vue&type=script&lang=js"
export * from "./rulesUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports